// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__2BU6g","author":"Table_author__5THGn","authorImage":"Table_authorImage__LfQ4X","unreadRow":"Table_unreadRow__34CG0"};